<template>
  <div>
    <header-tmpl></header-tmpl>
      <router-view></router-view>
    <footer-tmpl></footer-tmpl>
  </div>
</template>
<script>
import HeaderTmpl from './header.vue'
import FooterTmpl from './footer.vue'

export default {
  components: {
    HeaderTmpl,
    FooterTmpl
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/main.layout.vue